import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _cache[1] || (_cache[1] = _createElementVNode("p", { class: "mb-3" }, "Please type your answer in the box below", -1)),
    _createElementVNode("div", null, [
      _withDirectives(_createElementVNode("textarea", {
        class: "textarea",
        type: "text",
        placeholder: "Enter your answer...",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedAnswers) = $event)),
        rows: "4"
      }, null, 512), [
        [_vModelText, _ctx.selectedAnswers]
      ])
    ])
  ]))
}